import { UAParser } from 'ua-parser-js';
import { isDevelopment } from 'app/shared/utils/development';

const projectConfig: any = JSON.parse(process.env.REACT_APP_PROJECT_CONFIG!);

export const {
  website,
  config: {
    /**
     * data folder url path
     * local storage request like a api
     */
    remoteBucket,
    remoteCdn,
    /**
     * is this server allowed to connect external network ?
     */
    externalNetDisabled,
    /**
     * third party keys
     */
    ga: gaId,
    gtm: gtmId,
    amplitudeSurvey: amplitudeKey,
    googleRecaptchaKey,
    fileuploadEnable,
    defaultLanguage,
    facebookAppVersion,
    adLoginGoogleRecaptchaKey,
    enableAdLoginGoogleRecaptcha,
    surveyLoginFacebookAppId,
    surveyLoginFacebookAppSecret,
    languageWhitelist,
    tempAnswerEnable,
    hiddenSubmitEnable,
    activeDirectoryAutoLoginEnable,
    surveyLoginType,
    enableLogoLink
  }
} = projectConfig;

/**
 * setup branch from process.env
 */
export const branch = process.env.REACT_APP_BRANCH || '';

export const domain = {
  api: isDevelopment
    ? `${projectConfig.server.apiPath}`
    : `${projectConfig.server.api}${projectConfig.server.apiPath}`,
  assets: isDevelopment ? `/assets` : `${projectConfig.server.main}/assets`,
  server: projectConfig.server.main,
  file: (() => {
    if (!remoteBucket) {
      return isDevelopment ? `/s3` : `${projectConfig.server.main}/s3`;
    }

    return remoteBucket;
  })(),
  image: (() => {
    if (!remoteBucket) {
      return isDevelopment ? `/s3` : `${projectConfig.server.main}/s3`;
    }

    if (!remoteCdn) {
      return remoteBucket;
    }

    return remoteCdn;
  })(),
  shorten: 'https://s3-us-west-2.amazonaws.com/shorten.surveycake/u'
};

export const isInIframe = (() => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
})();

const userAgentData = new UAParser();

const isMobile = ['mobile', 'tablet'].includes(userAgentData.getDevice().type!);
const isIOS = navigator.userAgent.match(/(iPad|iPhone)/i) !== null;
const isFirefox = navigator.userAgent.match(/Firefox/i) !== null;
const isIE = navigator.userAgent.match(/MSIE|rv:11.0/i) !== null;

function parseIOSAppVersion() {
  const v = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
  if (v === null) {
    return false;
  }
  return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || '0', 10)];
}

const testiOSVersionBelow12 = () => {
  if (isIOS) {
    const version = parseIOSAppVersion();
    if (!version) {
      // 奇怪的 user agent
      return false;
    }
    if (version[0] <= 12) {
      return true;
    }
  }
  return false;
};

const isIOSVersionBelow12 = testiOSVersionBelow12();

export const userAgent = {
  isMobile,
  isIOS,
  isFirefox,
  isIE,
  isIOSVersionBelow12
};

export const enterprise = {
  is: branch.startsWith('enterprise'),
  name: (() => {
    const result = /^enterprise-(.*)$/.exec(branch);
    return result ? result[1].split('-')[0] : null;
  })(),
  exactName: (() => {
    const result = /^enterprise-(.*)$/.exec(branch);
    return result ? result[1] : null;
  })()
};
